<template>
  <div class="wrp">
    <div>
      <b-container fluid class="anns">
        <b-row class="annslist">
          <b-col>
            <b-img :src="priceListURL" fluid></b-img>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import http from "../http.js";
import qs from "qs";
export default {
  data() {
    return {
      priceListURL: "",
      tutorChatToken: ""
    };
  },
  created() {
    document.title = "價格表";
    http
      .post(
        "/SCRMApp/GetPriceList",
        qs.stringify({
          tutorChatToken: this.$route.query.tct
        })
      )
      .then(response => {
        this.priceListURL = response.data.Result;
      })
      .catch(function(error) {
        console.log(error);
        window.location.href = "/#/Error";
      });
  }
};
</script>
<style scoped>
#app {
  position: static;
}
.anns {
  max-width: 1140px;
  padding: 0px;
}
.annslist {
  position: relative;
  display: block;
  margin-bottom: 20px;
  margin-top: 20px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background: #fff;
}
.annslist:last-child {
  margin-bottom: 0;
  border-bottom: none;
}
</style>


// WEBPACK FOOTER //
// src/views/MobilePriceListView.vue